import { render, staticRenderFns } from "./orderDetails.vue?vue&type=template&id=401fbe1e&scoped=true"
import script from "./orderDetails.vue?vue&type=script&lang=js"
export * from "./orderDetails.vue?vue&type=script&lang=js"
import style0 from "./orderDetails.vue?vue&type=style&index=0&id=401fbe1e&prod&lang=scss"
import style1 from "./orderDetails.vue?vue&type=style&index=1&id=401fbe1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401fbe1e",
  null
  
)

export default component.exports